import { config } from '../config';
import { api } from '../utils/apiUtils';

/**
 * Service for managing workspace white label bindings
 */
class WorkspaceWhiteLabelService {
  /**
   * Get available white label instances for a workspace
   * @param {string} workspaceId - Workspace ID or shortId
   * @returns {Promise} Available instances and current binding
   */
  async getAvailableInstances(workspaceId) {
    try {
      const response = await api.get(
        `${config.API_URI}/v1/workspace/${workspaceId}/white-label/available`
      );
      return response;
    } catch (error) {
      console.error('Error fetching available white label instances:', error);
      throw error;
    }
  }

  /**
   * Bind workspace to a white label instance
   * @param {string} workspaceId - Workspace ID or shortId
   * @param {string} whiteLabelInstanceId - White label instance ID
   * @returns {Promise} Binding result
   */
  async bindWorkspace(workspaceId, whiteLabelInstanceId) {
    try {
      const response = await api.post(
        `${config.API_URI}/v1/workspace/${workspaceId}/white-label/bind`,
        { whiteLabelInstanceId }
      );
      return response;
    } catch (error) {
      console.error('Error binding workspace to white label:', error);
      throw error;
    }
  }

  /**
   * Unbind workspace from white label instance
   * @param {string} workspaceId - Workspace ID or shortId
   * @returns {Promise} Unbind result
   */
  async unbindWorkspace(workspaceId) {
    try {
      const response = await api.post(
        `${config.API_URI}/v1/workspace/${workspaceId}/white-label/unbind`
      );
      return response;
    } catch (error) {
      console.error('Error unbinding workspace from white label:', error);
      throw error;
    }
  }
}

export default new WorkspaceWhiteLabelService();

